export const localStorageItems = {
  appLanguage: 'lang',
  appThemeMode: 'myEnglishVocabularyThemeMode',
  appThemeColorScheme: 'myEnglishVocabularyThemeColorScheme',
  accessToken: 'accessToken',
};
